<template>
	<div class="row">
		<div v-if="isReady" class="col-12">
			<h4>{{ $t('acte.trigger.changement_proprietaire_titre') }}</h4>
			<p>{{ $t('acte.trigger.changement_proprietaire_desc', { porteuse: porteuse ? porteuse.horse_nom : '', donneuse: donneuse ? donneuse.horse_nom : '' }) }}</p>

			<HorseAjout
				ref="horseAjout"
				:horse="{ horse_id: porteuse.horse_id }"
				:preset_tiers="preset_tiers"
				:default_date="date_acte"
				:tiers_horse="[]"
				:add-or-edit-ready.sync="add_ready"
			/>

			<div class="text-center mt-3">
				<b-button variant="primary" class="rounded-pill" :disabled="processing" @click="save">
					<font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse /> {{ $t('global.enregistrer') }}
				</b-button>
				<button @click="continueNext" class="btn btn-secondary rounded-pill ml-2" :disabled="processing">
					<font-awesome-icon :icon="['fal', 'times']" /> {{ $t('acte.trigger.ignorer') }}
				</button>
			</div>
		</div>

		<LoadingSpinner v-else class="col-12" />
	</div>
</template>

<script type="text/javascript">
import { EventBus } from 'EventBus'
import Navigation from '@/mixins/Navigation.js'
import Shutter from '@/mixins/Shutter.js'
import ShutterTriggers from '@/mixins/shutters-manager/Triggers.js'
import ActesMixin from '@/mixins/Actes.js'
import HorseMixin from '@/mixins/Horse.js'

export default {
	name: 'ChangementProprietaire',
	mixins: [Navigation, Shutter, ShutterTriggers, ActesMixin, HorseMixin],
	props: {
		horses_ids: { type: Array, default: () => [] },
		actes_ids: { type: Array, default: () => [] },
		date_acte: { default: () => null },
		shutter_name: { type: String, default: () => 'changement_proprietaire' },
		next: { type: Array, default: () => [] }
	},
	data: () => ({
		isReady: false,
		processing: false,
		porteuse: null,
		donneuse: null,
		preset_tiers: null,
		add_ready: false
	}),
	mounted() {
		this.init_component()
	},
	methods: {
		async init_component() {
			this.isReady = false

			// L'acte porte une question "Étalon" qui référence un couple/trouple (season_mare_stallion)
			const sms = await this.getSeasonMareStallionFromActe(this.actes_ids[0])

			// Trouple uniquement : la porteuse doit être renseignée. Sinon (couple) on passe au suivant.
			if(!sms || !sms.seasonmarestallion_porteuse) {
				this.continueNext()
				return
			}

			// Donneuse : seasonmarestallion_seasonmare -> season_mare -> seasonmare_horse
			const season_mare = await this.$storage.db.t('season_mare').then(table => table.get(parseInt(sms.seasonmarestallion_seasonmare)))
			const donneuse_id = season_mare ? season_mare.seasonmare_horse : null

			// Porteuse : seasonmarestallion_porteuse -> season_mare -> seasonmare_horse
			const porteuse_season_mare = await this.$storage.db.t('season_mare').then(table => table.get(parseInt(sms.seasonmarestallion_porteuse)))
			const porteuse_id = porteuse_season_mare ? porteuse_season_mare.seasonmare_horse : null

			if(!donneuse_id || !porteuse_id) {
				this.continueNext()
				return
			}

			this.porteuse = await this.$storage.db.t('horse').then(table => table.get(parseInt(porteuse_id)))
			this.donneuse = await this.$storage.db.t('horse').then(table => table.get(parseInt(donneuse_id)))

			// Tiers actuels de la porteuse (avec leur tiershorse_id pour mise à jour et non duplication)
			const porteuse_tiers = await this.loadTiersCurrentPart(porteuse_id)
			const current = porteuse_tiers ? porteuse_tiers.tiers_horse : []
			const current_ids = current.map(t => t.tiers.tiers_id)

			// Tiers de la donneuse absents de la porteuse, pré-remplis avec leurs %
			const donneuse_tiers = await this.loadTiersCurrentPart(donneuse_id)
			const donneuse_missing = (donneuse_tiers ? donneuse_tiers.tiers_horse : []).filter(d => !current_ids.includes(d.tiers.tiers_id)).map(d => ({
				tiershorse_id: null,
				tiers: { tiers_id: d.tiers.tiers_id, tiers_rs: d.tiers.tiers_rs },
				tiers_horse_part: {
					tiershorsepart_propriete: d.tiers_horse_part.tiershorsepart_propriete,
					tiershorsepart_pension: d.tiers_horse_part.tiershorsepart_pension,
					tiershorsepart_frais: d.tiers_horse_part.tiershorsepart_frais,
					tiershorsepart_contract: d.tiers_horse_part.tiershorsepart_contract,
					tiershorsepart_entraineur: 0,
					tiershorsepart_jockey: 0
				}
			}))

			this.preset_tiers = [...current, ...donneuse_missing]
			this.isReady = true
		},
		async save() {
			if(this.processing) return
			this.processing = true
			const result = await this.$refs.horseAjout.checkForm()
			this.processing = false
			if(result) {
				this.continueNext()
			}
		},
		continueNext() {
			this.shutterPanel().close(this.shutter_name)
			if(this.next.length > 0) {
				const triggered = this.next[0]
				this.next.shift()
				this.setupNewTriggered(triggered.horses, triggered.date, triggered.type, null, this.next, null, triggered.actes_ids)
			}
			else {
				EventBus.$emit('GynecologieHorse::reload')
				this.$router.push({ name: 'HorseGynecologie', params: { horse_id: this.horses_ids[0] } })
			}
		}
	},
	components: {
		LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
		HorseAjout: () => import('@/components/Tiers/HorseAjout')
	}
}
</script>
